const shareText = 'Just a better place to watch movies online for free.It allows you to watch movies online in high quality for free. No registration is required. The content is updated daily with fast streaming servers, multi-language subtitles supported. Just open and watch your favorite movies, tv-shows. We have almost any movie, tv-shows you want to watch!';

export default shareText;
